import React, { useCallback } from 'react';
import {
  Button, ButtonProps,
} from '@fluentui/react-components';
import { useEvent } from '@bingads-webui-react/event-provider';

import { useDataSelection } from '@bingads-webui-react/data-selection';

interface ConfirmButtomProps {
  label: string;
  onConfirm: (dataSelection: any[]) => void;
}

export const ConfirmButton: React.FC<ConfirmButtomProps & ButtonProps> = ({ label, onConfirm }) => {
  const { dataSelection } = useDataSelection();
  const closeDrawer = useEvent('close-drawer', undefined);

  const onClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    onConfirm(dataSelection);
    closeDrawer(undefined);
  }, [dataSelection, closeDrawer, onConfirm]);

  return (
    <Button
      className="confirm-button"
      appearance="primary"
      onClick={onClick}
      disabled={dataSelection.length === 0}
    >
      {label}
    </Button>
  );
};
